(function(){
  if(window.__smPerformanceGuardV2)return;
  window.__smPerformanceGuardV2=true;
  function tuneImages(scope){
    (scope||document).querySelectorAll('img').forEach(function(img){
      if(img.closest('.smx-hero,.sm-logo-header,.sm-site-chrome'))return;
      if(!img.hasAttribute('loading'))img.loading='lazy';
      if(!img.hasAttribute('decoding'))img.decoding='async';
    });
  }
  function pauseOffscreenMotion(){
    if(!('IntersectionObserver' in window))return;
    var targets=document.querySelectorAll('.sm-featured-wall,[data-sm-home-bio],[data-sm-home-handdrawn-upper]');
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){e.target.classList.toggle('sm-perf-offscreen',!e.isIntersecting)});
    },{rootMargin:'300px 0px'});
    targets.forEach(function(el){io.observe(el)});
  }
  function boot(){
    tuneImages(document);
    pauseOffscreenMotion();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',function(e){tuneImages(e.target)});
})();